import { Keypair, PublicKey, TransactionInstruction } from "@solana/web3.js";
import {
  CrossbarClient,
  IOracleFeed,
  OracleJob,
} from "@switchboard-xyz/common";
import * as sb from "@switchboard-xyz/on-demand";

import { getDepositQueueAddress, getRangeApiKey, getRpcEndpoint } from "./config";

export function getRangeRiskScoreJob(address: string): OracleJob {
  return OracleJob.fromObject({
    tasks: [
      {
        httpTask: {
          url: `https://api.range.org/v1/risk/address?address=${address}&network=solana`,
          headers: [
            { key: "accept", value: "application/json" },
            { key: "X-API-KEY", value: "${RANGE_API_KEY}" },
          ],
        },
      },
      { jsonParseTask: { path: "$.riskScore" } },
      { multiplyTask: { scalar: 10 } },
      {
        boundTask: {
          lowerBoundValue: "0",
          onExceedsLowerBoundValue: "0",
          upperBoundValue: "100",
          onExceedsUpperBoundValue: "100",
        },
      },
    ],
  });
}

export async function getOracleQuote(
  payer: Keypair | PublicKey,
  addressToCheck: string
): Promise<{
  queueAccount: PublicKey;
  sigVerifyIx: TransactionInstruction;
}> {
  const rpcUrl = getRpcEndpoint();
  const rangeApiKey = getRangeApiKey();

  const queue = await sb.getQueue({
    solanaRPCUrl: rpcUrl,
    queueAddress: getDepositQueueAddress(),
  });

  const crossbarClient = CrossbarClient.default();

  const feed: IOracleFeed = {
    name: "Risk Score",
    jobs: [getRangeRiskScoreJob(addressToCheck)],
    minJobResponses: 1,
    minOracleSamples: 1,
    maxJobRangePct: 100,
  };

  const sigVerifyIx = await queue.fetchQuoteIx(crossbarClient, [feed], {
    variableOverrides: { RANGE_API_KEY: rangeApiKey },
    numSignatures: 1,
    instructionIdx: 0,
  });
  return { queueAccount: queue.pubkey, sigVerifyIx };
}
